import { iconsListData as webIconNames } from "../../themes/web/assets/icons/icons-list/iconsListData";
import { iconsListData as responsiveIconNames } from "../../themes/responsive/assets/icons/icons-list/iconsListData";
export const AVAILABLE_ICONS = {
    // @ts-expect-error Check for typing
    web: webIconNames,
    // @ts-expect-error Check for typing
    responsive: responsiveIconNames
};
//# sourceMappingURL=constants.js.map
